module.exports = __webpack_public_path__ + "static/presidents-message-d35c1aae0a9eda9d087f3ba806b8d580.jpg";